import React, { useState, useCallback, useEffect, useMemo } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Paging,
  Pager,
  Button,
} from "devextreme-react/data-grid";

import Button1 from "@material-ui/core/Button";
import Select from "react-select";
import swal from "sweetalert";
import axios from "axios";

import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";

import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Guid from "devextreme/core/guid";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import useDeviceSize from "../../hooks/useDeviceSize";
import { api_path } from "../../shared.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

export function CustomerRegisterDatagrid(props) {
  const [width, height] = useDeviceSize();
  const classes = useStyles();
  const [getUserRole, setGetUserRole] = useState(
    String(props.USER_ROLE ?? "").trim(),
  );
  useEffect(() => {
    setGetUserRole(String(props.USER_ROLE ?? "").trim());
  }, [props.USER_ROLE]);

  const [open, setOpen] = useState(false);
  const [GET_DATE_FROM, SET_DATE_FROM] = useState("");
  const [GET_DATE_TO, SET_DATE_TO] = useState("");
  // ── Search state ─────────────────────────────────────────
  const [GET_SMF_CODE, SET_SMF_CODE] = useState("");
  const [GET_CUSTOMER_NAME, SET_CUSTOMER_NAME] = useState("");
  const [GET_TAXID, SET_TAXID] = useState("");
  const [getStatus, setStatus] = useState(null);
  const [getType, setType] = useState(null);
  const [selectStatus, setSelectStatus] = useState("");
  const [selectType, setSelectType] = useState("");
  const [searchParams, setSearchParams] = useState({});

  const token = process.env.REACT_APP_API_TOKEN;

  // const typeList = useMemo(() => [
  //   { value: "1", label: "Customer" },
  //   { value: "2", label: "Agent" },
  //   { value: "3", label: "Vendor" },
  // ], []);
const typeList = useMemo(() => [
  { value: "CUSTOMER", label: "Customer" },
  { value: "AGENT",    label: "Agent" },
  { value: "VENDOR",   label: "Vendor" },
  { value: "consingnee",   label: "Consingnee" },
  { value: "notify",   label: "Notify" },
], []);
  const statusList = [
    { value: "1", label: "DRAFT" },
    { value: "2", label: "NEW" },
    { value: "3", label: "PENDING REVIEW" },
    { value: "4", label: "REVIEWED" },
    { value: "5", label: "VETTED" },
    { value: "6", label: "APPROVED" },
    { value: "7", label: "COMPLETED" },
    { value: "8", label: "REJECT" },
  ];

  // ── Handlers ─────────────────────────────────────────────
  const handleStatusChange = (obj) => {
    setSelectStatus(obj?.value ?? "");
    setStatus(obj);
  };
  const handleTypeChange = (obj) => {
    setSelectType(obj?.value ?? "");
    setType(obj);
  };
const handleSearch = () => {
  setSearchParams({
    name:   GET_CUSTOMER_NAME,
    code:   GET_SMF_CODE,
    taxid:  GET_TAXID,
    type:   selectType,
    status: selectStatus,
    dateFrom: GET_DATE_FROM,
    dateTo:   GET_DATE_TO,
  });
};
  const handleClearInputClick = () => {
    SET_SMF_CODE("");
    SET_CUSTOMER_NAME("");
    SET_TAXID("");
    setStatus(null);
    setType(null);
    setSelectStatus("");
    setSelectType("");
    SET_DATE_FROM("");
    SET_DATE_TO("");
    setSearchParams({});
  };
  const handleSelectType = (type) => {
    setOpen(false);
    window.open(`/s-crm/CustomerRegisterForm?type=${type}`, "_blank");
  };
  const handleAddButtonClick = () => setOpen(true);

  // ── DataSource ───────────────────────────────────────────
const url = useMemo(() => {
  const params = new URLSearchParams();
  if (searchParams.name)   params.append("name",   searchParams.name);
  if (searchParams.code)   params.append("code",   searchParams.code);
  if (searchParams.taxid)  params.append("taxid",  searchParams.taxid);
  if (searchParams.type)   params.append("type",   searchParams.type);
  if (searchParams.status) params.append("status", searchParams.status);
  if (searchParams.dateFrom) params.append("date_from", searchParams.dateFrom);
  if (searchParams.dateTo)   params.append("date_to",   searchParams.dateTo);  
  // เพิ่ม USER_ID และ ROLE
  const userId = JSON.parse(localStorage.getItem("USER_ID"));
  const role   = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  params.append("user_id", userId ?? "");
  params.append("role",    role   ?? "");
  return `${api_path}/customer/customerRegister.php?${params.toString()}`;
}, [searchParams]);
  const dataSource = useMemo(() => createStore({
    key: "ID",
    loadUrl: url,
    reshapeOnPush: true,
    onBeforeSend(method, ajaxOptions) {
      ajaxOptions.crossDomain = true;
      ajaxOptions.headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
    },
  }), [url]);

  // ── Export ───────────────────────────────────────────────
  const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("CustomerRegister");
    exportDataGrid({ component: e.component, worksheet, autoFilterEnabled: true })
      .then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: "application/octet-stream" }), "CustomerRegister.xlsx");
        });
      });
  };

  // ── Row actions ──────────────────────────────────────────
  const onEditButtonClick = useCallback((e) => {
    const dataRow = e.row?.data;
    window.open(`/s-crm/CustomerRegisterForm?id=${e.row.key}&type=${dataRow.SourceID}`, "_blank");
  }, []);

  const onViewButtonClick = useCallback((e) => {
    const dataRow = e.row?.data;
    window.open(`/s-crm/CustomerRegisterDetail?id=${e.row.key}&type=${dataRow.SourceID}`, "_blank");
  }, []);

  const onBookingButtonClick = useCallback((e) => {
    const dataRow = e.row?.data;
    window.open(`/s-crm/CustomerRegisterDetail?id=${e.row.key}&type=${dataRow.SourceID}`, "_blank");
  }, []);

  const onDeleteButtonClick = (e) => {
    swal({ title: "Are you sure?", text: "You want to delete this data?", icon: "warning", dangerMode: true, buttons: true })
      .then((willDelete) => { if (willDelete) deleteRow(e.row.key); });
  };

  const deleteRow = async (id) => {
    try {
      await axios.delete(`${api_path}/customer/CustomerRegisterForm.php?id=${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      console.error(error);
    }
  };

  // ── Visibility helpers ───────────────────────────────────
  const isDelelteIconVisible = (e) => e.row.data.approval_status === "1";
  const isBookingIconVisible = (e) => e.row.data.approval_status === "0";

  // ── Role ─────────────────────────────────────────────────
  const allowedRoles = ["3", "7", "8", "9", "14"];
  const isAllowed = allowedRoles.includes(getUserRole);
  const gridSize = isAllowed ? 8 : 12;

  const StatusCell = React.memo(({ data }) => {
  const statusClass = data.approval_status_name?.replace(/\s+/g, "_");
  const textColor = data.approval_status_name === "DRAFT" ? "#000" : "#fff";
  return (
    <div className={`customer_status${statusClass}`}>
      
        <a href={`CustomerRegisterDetail?id=${data.ID}&type=${data.SourceID}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: textColor }}
        title="View"
      >
        {data.approval_status_name}
      </a>
    </div>
  );
});

const TypeCell = React.memo(({ data }) => (
  <div className={`customer_type${data.SourceType}`}>
    
      <a href={`CustomerRegisterDetail?id=${data.ID}&type=${data.SourceID}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#000" }}
      title="View"
    >
      {data.SourceType}
    </a>
  </div>
));

  // ── Render ───────────────────────────────────────────────
  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>&nbsp;</Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={10}>
          <label className="head">New Customer Registration</label>
        </Grid>
        <Grid item xs={12} sm={2} style={{ display: "flex" }} justify="flex-end">
          <Button1 className="addBtn" variant="contained" color="primary" fullWidth onClick={handleAddButtonClick}>
            New Customer
          </Button1>
        </Grid>
      </Grid>

      {/* ── Search bar ── */}
      <Grid container spacing={2}>
     
        <Grid item xs={12} sm={2}>
          <label>CODE</label>
          <TextField size="small" variant="outlined" fullWidth value={GET_SMF_CODE} onChange={(e) => SET_SMF_CODE(e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Customer</label>
          <TextField size="small" variant="outlined" fullWidth value={GET_CUSTOMER_NAME} onChange={(e) => SET_CUSTOMER_NAME(e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>TAX ID</label>
          <TextField size="small" variant="outlined" fullWidth value={GET_TAXID} onChange={(e) => SET_TAXID(e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>STATUS</label>
          <Select
            placeholder="Select..."
            value={getStatus}
            options={statusList}
            onChange={handleStatusChange}
            getOptionLabel={(x) => x.label}
            getOptionValue={(x) => x.value}
            isClearable
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>TYPE</label>
          <Select
            placeholder="Select..."
            value={getType}
            options={typeList}
            onChange={handleTypeChange}
            getOptionLabel={(x) => x.label}
            getOptionValue={(x) => x.value}
            isClearable
          />
        </Grid>
        {/* ── Date filter row ── */}
<Grid container spacing={2}>
  <Grid item xs={12} sm={2}>
    <label>DATE FROM</label>
    <TextField
      size="small"
      variant="outlined"
      fullWidth
      type="date"
      value={GET_DATE_FROM}
      onChange={(e) => SET_DATE_FROM(e.target.value)}
      InputLabelProps={{ shrink: true }}
    />
  </Grid>
  <Grid item xs={12} sm={2}>
    <label>DATE TO</label>
    <TextField
      size="small"
      variant="outlined"
      fullWidth
      type="date"
      value={GET_DATE_TO}
      onChange={(e) => SET_DATE_TO(e.target.value)}
      InputLabelProps={{ shrink: true }}
      inputProps={{ min: GET_DATE_FROM || undefined }}
    />
  </Grid>
</Grid>
        <Grid item xs={12} sm={gridSize} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
          <Button1 className="searchButton" variant="contained" color="primary" onClick={handleSearch}>
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1 className="searchButton" variant="outlined" color="primary" onClick={handleClearInputClick}>
            Clear Filter
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1 className="searchButton" variant="outlined" color="primary" onClick={() => setSearchParams({ ...searchParams })}>
            Refresh data
          </Button1>
        </Grid>
      </Grid>

      {/* ── DataGrid ── */}
      <Grid container className={classes.root}>
        <DataGrid
          id="GlobalSearchContainer"
          dataSource={dataSource}
          keyExpr="ID"
          columnAutoWidth={true}
          height={height}
          onExporting={onExporting}
          showBorders={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
        >
          <Paging defaultPageSize={25} />
          <Scrolling rowRenderingMode="virtual" showScrollbar="always" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <SearchPanel visible={true} width={240} placeholder="Search Customer / Vendor / Agent..." />

          <Column dataField="SourceType" caption="Type" width={120} alignment="left" cellRender={({ data }) => <TypeCell data={data} />} />
          <Column dataField="CreatedDate" dataType="date" caption="Created Date" width={120} format="dd-MMM-yyyy"/>
          <Column dataField="Code" caption="Code" width={120} />
          <Column dataField="NameTH" caption="Name (TH)" />
          <Column dataField="NameEN" caption="Name (EN)" />
          <Column dataField="TaxID" caption="Tax" width={140} />
          <Column dataField="Mobile" caption="Mobile" width={140} />
          <Column dataField="Email" caption="Email" width={200} />
          <Column dataField="ContactPerson" caption="Contact" width={160} />
          <Column dataField="CreditLimit" caption="CREDIT LIMIT" format="#,##0" alignment="right" visible={false} />
          <Column dataField="CreditDay" caption="CREDIT DAY" visible={false} />
          <Column
            dataField="approval_status_name"
            caption="Status"
            width={140}
            cellRender={({ data }) => <StatusCell data={data} />}
          />
          <Column type="buttons" caption="Actions" fixed={true} allowFiltering={false} allowHeaderFiltering={false}>
            <Button icon="edit"    onClick={onEditButtonClick}    hint="Edit" />
            <Button icon="search"  onClick={onViewButtonClick}    hint="View details" />
            <Button icon="message" onClick={onBookingButtonClick} hint="Send" visible={isBookingIconVisible} />
            <Button icon="trash"   onClick={onDeleteButtonClick}  hint="Delete" visible={isDelelteIconVisible} />
          </Column>

          <ColumnChooser enabled={true}>
            <Position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button" />
            <ColumnChooserSearch enabled={true} />
            <ColumnChooserSelection allowSelectAll={true} />
          </ColumnChooser>

          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={[10, 25, 50, 100]} showPageSizeSelector={true} />
          <LoadPanel enabled={true} />
        </DataGrid>
      </Grid>

      {/* ── New Customer Dialog ── */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle style={{ textAlign: "center", fontWeight: "bold", fontSize: 20 }}>
          Select Business Partner Type
        </DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column", gap: 15, marginTop: 10 }}>
            <Button1 variant="outlined" size="large" onClick={() => handleSelectType("1")} style={{ padding: 15, fontSize: 16, borderRadius: 8 }}>
              Local Customer
            </Button1>
            <Button1 variant="outlined" size="large" onClick={() => handleSelectType("2")} style={{ padding: 15, fontSize: 16, borderRadius: 8 }}>
              Oversea
            </Button1>
            <Button1 variant="outlined" size="large" onClick={() => handleSelectType("3")} style={{ padding: 15, fontSize: 16, borderRadius: 8 }}>
              Supplier / Vendor
            </Button1>
          </div>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center", paddingBottom: 20 }}>
          <Button1 onClick={() => setOpen(false)} color="secondary">
            Cancel
          </Button1>
        </DialogActions>
      </Dialog>
    </Container>
  );
}